import { apiClient } from '@/lib/api-client';

// ─── Types ──────────────────────────────────────────────────────────────────

export interface FloorLayout {
  id: string;
  tenant_id: string;
  location_id: string;
  layout: { tables: TablePositionEntry[] };
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface TablePositionEntry {
  table_id: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

// ─── Helpers ────────────────────────────────────────────────────────────────

function buildQuery(params: Record<string, string | undefined | null>): string {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

// ─── Service ────────────────────────────────────────────────────────────────

export const floorLayoutService = {
  async get(locationId: string): Promise<FloorLayout | null> {
    try {
      return await apiClient<FloorLayout>(
        `/floor-layout${buildQuery({ location_id: locationId })}`,
      );
    } catch {
      return null;
    }
  },

  async save(
    locationId: string,
    positions: Record<string, { x: number; y: number; width: number; height: number }>,
  ): Promise<FloorLayout> {
    const tables: TablePositionEntry[] = Object.entries(positions).map(([table_id, pos]) => ({
      table_id,
      x: pos.x,
      y: pos.y,
      width: pos.width,
      height: pos.height,
    }));
    return apiClient<FloorLayout>('/floor-layout', {
      method: 'POST',
      body: { location_id: locationId, layout: { tables } },
    });
  },
};
